import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Address } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";
import { useAuthStore } from "../../lib/stores/auth";

export interface AddressInput {
  id?: string;
  label?: string;
  fullName: string;
  phone: string;
  line1: string;
  line2?: string;
  city: string;
  province: string;
  postalCode: string;
  country: string;
  isDefault: boolean;
}

export function useAddresses() {
  const isAuthenticated = useAuthStore((s) => s.status === "authenticated");
  return useQuery({
    queryKey: ["addresses"],
    queryFn: () => apiFetch<{ items: Address[] }>("/addresses").then((r) => r.items),
    enabled: isAuthenticated
  });
}

export function useUpsertAddress() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AddressInput) =>
      apiFetch<{ address: Address }>("/addresses", { method: "POST", body: JSON.stringify(input) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["addresses"] })
  });
}

export function useDeleteAddress() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiFetch<void>(`/addresses/${id}`, { method: "DELETE" }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["addresses"] })
  });
}
